export default __webpack_public_path__ + "static/media/5.67213274.svg";